import config from '@/config'
import { store } from '@/store/store'
import axios from 'axios'

const instance = () =>
  axios.create({
    baseURL: `${config.serverUrl}api/wrs`,
    timeout: 30000,
    headers: {
      AUTHORIZATION: store.getters.securityToken
    }
  })

const wrsApi = {
  postWrsSyncBoard: (data) => {
    return instance().post('/sync-board', data)
  },
  getWrsCouponCode: (params) => {
    return instance().get('/coupon-code', { params })
  }
}

export default wrsApi



// WEBPACK FOOTER //
// ./src/api/wrs.js